// extracted by mini-css-extract-plugin
module.exports = {"Register":"Styles_Register__1KhKg","Form":"Styles_Form__1F_F_","Center":"Styles_Center__2rpkf","red":"Styles_red__23jyF"};